var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppHeader',{attrs:{"title":"지점 예약","is-modal-menu":""}}),_c('AppContent',[_c('ReservationApp')],1),_c('AppFooter'),_c('ReservationAppModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }